import { Component, inject, input, OnInit, output, signal, TemplateRef, viewChild } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../core/utils";
import { FormActionButtonsComponent, FormInputComponent } from "../../../shared/components";
import { Constants } from "../../../shared/constants/constants";
import { AdaaBoolean, PageMode } from "../../../shared/constants/enums";
import { ValidatorModelType } from "../../../shared/models";
import { LookupContent } from "../../../shared/models/lookup-content-model";
import { LanguageService, ValidatorApiService } from "../../../shared/services";

@Component({
  selector: "adaa-lookup-content-editor",
  imports: [FormInputComponent, FormActionButtonsComponent, TranslatePipe, ReactiveFormsModule],
  templateUrl: "./lookup-content-editor.html",
  styleUrl: "./lookup-content-editor.scss",
})
export class LookupContentEditorComponent implements OnInit {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _modalService = inject(NgbModal);
  private readonly _languageService = inject(LanguageService);
  private readonly _toastrService = inject(ToastrService);
  private readonly _validatorApiService = inject(ValidatorApiService);

  modal = viewChild.required<TemplateRef<unknown>>("content");

  pageMode = input.required<string>();

  editorClosed = output<LookupContent>();
  PageMode = PageMode;

  lookupForm: FormGroup = new FormGroup({});
  submitted = signal<boolean>(false);
  formValidation = signal<ValidatorModelType | undefined>(undefined);

  public get displayLabel(): string {
    const labelEN = this.lookupForm.get("labelEN")?.value;
    const labelAE = this.lookupForm.get("labelAE")?.value;

    return AdaaHelper.getPageLabel(labelAE, labelEN);
  }

  public ngOnInit() {
    this._prepareForm();
  }

  private _prepareForm() {
    this.lookupForm = this._formBuilder.group({
      nameAE: null,
      nameEN: null,
      propType: null,
      id: null,
      labelAE: null,
      labelEN: null,
      value: null,
    });

    this._validatorApiService
      .applyValidationToForm(Constants.VALIDATORS_CONF_KEY.VALIDATION_LOOKUP, this.lookupForm)
      .subscribe({
        next: (response) => {
          this.lookupForm = response.form;
          this.formValidation.set(response.validation);
        },
      });
  }

  public open() {
    this._modalService.open(this.modal(), {
      animation: true,
      scrollable: false,
      keyboard: false,
      size: "xl",
      centered: true,
      modalDialogClass: this._languageService.modalDirection(),
    });

    this.submitted.set(false);
  }

  public submit() {
    this.submitted.set(true);
    if (this.lookupForm.invalid) {
      this._toastrService.error(this._languageService.translate("common.form.label.missing_information"));
      return;
    }
    const result = {
      ...this.lookupForm.value,
      enabled: AdaaBoolean.Y,
    };

    this.editorClosed.emit(result);
  }

  public checkInvalid(control: string) {
    return (
      this.lookupForm.controls[control].errors?.["required"] &&
      (this.lookupForm.get("nameEN")?.dirty || this.submitted())
    );
  }
}
